/// <reference path="../types/index.d.ts" />

import '../client_forms/oliveevents2/style.css';
import FormStructure from './oliveevents2/form_structure';

export default FormStructure;